import { combineReducers, configureStore } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage";
import { createTransform, persistReducer, persistStore } from "redux-persist";
import authReducer from "../slices/auth-slice";
import editorReducer from "../slices/editor/editorSlice";
import publisherReducer from "../slices/publisher/publisherSlice";
import affiliateThemeReducer from "../slices/affiliateTheme";
import fetchAffiliateReducer from "../slices/fetchAffiliate";
import previewReducer from "../slices/commonSlice/preview";
import updateThemeReducer from "../slices/updateThemeSlice";
import themeReducer from "../slices/commonSlice/themeSlice";
import themeGalleryReducer from "../slices/themeGallery-slice";


const rootReducter = combineReducers({
  auth: authReducer, // Login api work slice
  editor: editorReducer, // edite theme data 
  publish: publisherReducer, // Publicer api work slice
  affiliateData: affiliateThemeReducer, // affiliate api work slice
  fetchAffiliate: fetchAffiliateReducer, // this is fetch Affiliate 
  preview: previewReducer, // this is preview them work
  updateTheme: updateThemeReducer, // this is update api work
  theme: themeReducer,// update the Theme
  themeGallery: themeGalleryReducer // this is theme gallery
});

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["auth", "affiliateData", "fetchAffiliate", "preview", "defaultThemeOptions"],
  // transforms:[selectDataTransform] 
};

const presistReducter = persistReducer(persistConfig, rootReducter);

export const store = configureStore({
  reducer: presistReducter,
  devTools: false,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
